import React, { useEffect } from 'react'
import Layout from '~/components/Layout'
import Map from '~/features/Map/components/Map'
import useSystemState from '~/features/System/stores/SystemState'
import { useHookstate } from '@hookstate/core'
import MapMarkersEvents from '~/features/Map/components/MapMarkers/MapMarkersEvents'
import useUserState from '~/features/User/stores/UserState'
import { useLang } from '~/hooks/useLang'
import MapHandlePopUp from '~/features/Map/components/MapHandlers'
import ModalHistoricDevice from '~/features/Map/components/MarkerPopupContent/components/ModalHistoricDevice'
import { useMarkerState } from '~/features/Map/stores/MapState'

export default function HistoricMap() {
  const { windowDefault, markersViewVisible, windowIsVisible } = useSystemState()
  const { translate } = useLang()
  const viewGroups = useHookstate<string[]>(['deviceHistoric', 'dispatchHistoric'])
  const { popupMarker, markersState, forceClosePopup } = useMarkerState()


  useEffect(() => {
    document.title = translate('Historic Map - Dispatch System')
  }, [])

  useEffect(() => {
    windowDefault(['mapHistoricFilters'])
    windowIsVisible(['mapSetting'])
    markersViewVisible(['deviceHistoric']);

    return () => {
      markersState()['dispatchHistoric']?.set({})
      markersState()['deviceHistoric']?.set({})
    }
  }, [])

  return (
    <Layout mapViewPort marginLayout={false} draggableComponents={true}>
      <Map>
        <ModalHistoricDevice />
        <MapMarkersEvents
          viewGroups={viewGroups.get()}
          checkedViewGroups={['dispatchHistoric', 'deviceHistoric']}
        />
      </Map>
    </Layout>
  )
}
